<template>
  <div class="dashboard-page">

      <!-- Stats Cards Row -->
      <section class="stats-row">
        <div class="stat-card stat-card--blue">
          <div class="stat-icon">🏠</div>
          <div class="stat-info">
            <span class="stat-label">总门牌号</span>
            <span class="stat-value">{{ stats.menpainums }}</span>
          </div>
        </div>
        <div class="stat-card stat-card--orange">
          <div class="stat-icon">📋</div>
          <div class="stat-info">
            <span class="stat-label">异常门牌号数</span>
            <span class="stat-value">{{ stats.errhushu }}</span>
          </div>
        </div>
        <div class="stat-card stat-card--blue">
          <div class="stat-icon">👥</div>
          <div class="stat-info">
            <span class="stat-label">总用气人数</span>
            <span class="stat-value">{{ stats.psersonnums }}</span>
          </div>
        </div>
        <div class="stat-card stat-card--red">
          <div class="stat-icon">⚠️</div>
          <div class="stat-info">
            <span class="stat-label">异常总人数</span>
            <span class="stat-value">{{ stats.errperson }}</span>
          </div>
        </div>
        <div class="stat-card stat-card--green">
          <div class="stat-icon">✅</div>
          <div class="stat-info">
            <span class="stat-label">已整改数</span>
            <span class="stat-value">{{ stats.zhenggainums }}</span>
          </div>
        </div>
      </section>

      <!-- Charts Row -->
      <section class="charts-row">
        <!-- Left: Hazard Distribution -->
        <div class="chart-card chart-card--left">
          <h3 class="card-title">燃气厂家分布</h3>
          <div class="bar-chart">
            <div id="gasDistChart" style="width: 100%; height: 260px;"></div>
          </div>
        </div>

        <!-- Right: Village Stats -->
        <div class="chart-card chart-card--right">
          <h3 class="card-title">各组异常统计</h3>
          <div class="village-grid">
            <div
              class="village-mini-card"
              v-for="(village, index) in villageStats"
              :key="index"
            >
              <div class="village-mini-header">
                <span class="village-mini-name">{{ village.regionname }}</span>
              </div>
              <div class="village-mini-stats">
                <span class="village-stat-item">
                  户数: <em>{{ village.hushu || 0 }}</em>
                </span>
                <span class="village-stat-item">
                  用气人数: <em>{{ (village.errnums || 0) + (village.rightnums || 0) }}</em>
                </span>
                <span class="village-stat-item">
                  异常人数: <em>{{ village.errnums || 0 }}</em>
                </span>
              </div>
              <div class="village-mini-link" @click="gotoDetail(village)">详情 →</div>
            </div>
          </div>
        </div>
      </section>
      
        
      <!-- Tables Section -->
      <section class="table-section">
        <div class="table-footer">
            <router-link to="/gas/search" class="view-all-link">查看全部 →</router-link>
        </div>
        <h3 class="card-title">近期整改记录</h3>
        <el-table
          :data="rectifyRecords"
          border
          stripe
          style="width: 100%"
          size="small"
          header-cell-class-name="table-header-cell"
        >
          <el-table-column prop="create_time" label="时间"  width="150" />
          <el-table-column prop="regionname" label="组名" />
          <el-table-column prop="name" label="姓名" />
          <el-table-column prop="identity" label="身份" />
          <el-table-column prop="phone" label="联系方式" />
          <el-table-column prop="gas_supplier" label="燃气厂家" />
          <el-table-column label="安心管">
            <template slot-scope="scope">
              {{ scope.row.pipe_safe == '0' ? '正常' : '异常' }}
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" show-overflow-tooltip />
          <el-table-column prop="create_man" label="操作员" />
          <el-table-column label="状态">
            <template slot-scope="scope">
              <el-tag
                :type="scope.row.is_abnormal == '0' ? 'success' : 'danger'"
                size="small"
                effect="plain"
              >{{ scope.row.is_abnormal == '0' ? '正常' : '异常' }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="update_time" label="整改时间"  width="150" />
        </el-table>
      </section>

  </div>
</template>

<script>
import { getGasOverview, getGasRunDistribution, getCunZuYiChang, getUserpageList } from '@/api/gasdashboard'
export default {
  name: 'Dashboard',
  data() {
    return {
      stats: {
        menpainums: 0,
        psersonnums: 0,
        errperson: 0,
        errhushu: 0,
        zhenggainums: 0
      },
      villageStats: [],
      rectifyRecords: [],
      gasDistChart: null
    }
  },
  mounted() {
    this.getInfo();
    this.getAllGroupInfo();
    this.getUserList();
    this.getYinhuan();
    window.addEventListener('resize', this.handleChartResize);
  },
  beforeDestroy() {
    if (this.gasDistChart) {
      this.gasDistChart.dispose();
    }
    window.removeEventListener('resize', this.handleChartResize);
  },
  methods: { 
    getInfo() { 
        getGasOverview({
            'x-access-token': this.GLOBAL.token(),
            userid: this.GLOBAL.adminId()
        }).then((res) => {
            if (res.result == '200') {
                this.stats = res.detail;
            } else {
                this.$message.error(res.description);
            }
        })
    },
    getAllGroupInfo() { 
         getCunZuYiChang({
            'x-access-token': this.GLOBAL.token(),
            userid: this.GLOBAL.adminId()
        }).then((res) => {
            if (res.result == '200') {
                this.villageStats = res.detail;
            } else {
                this.$message.error(res.description);
            }
        })
    },
    getUserList(){
        getUserpageList({
            'x-access-token': this.GLOBAL.token(),
            userid: this.GLOBAL.adminId(),
            page: 1,
            pagesize: 10
        }).then((res) => {
            if (res.result == '200') {
                this.rectifyRecords = res.detail.list;
            } else {
                this.$message.error(res.description);
            }
        })
    },
    //燃气厂家分布
    getYinhuan() {
        getGasRunDistribution({
            'x-access-token': this.GLOBAL.token(),
            userid: this.GLOBAL.adminId()
        }).then((res) => {
            if (res.result == '200') {
                console.log(res);
                this.xAxisData = res.detail.ranqilist[0].names.split(',');
                this.yAxisData = res.detail.ranqilist[0].nums.split(',');
                this.initGasDistChart();
            } else {
                this.$message.error(res.description);
            }
        })
    },
    gotoDetail(data){
        this.$router.push({
            path: '/gas/village',
            query: {
                regioncode: data.regioncode,
                regionname: data.regionname
            }
        })
    },
    // 初始化图表
    initGasDistChart(){
        this.gasDistChart = this.$echarts.init(document.getElementById('gasDistChart'));
        this.gasDistChart.setOption({
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            xAxis: {
                type: 'category',
                data: this.xAxisData
            },
            yAxis: {
                type: 'value',
            },
            series: [
                {
                    data: this.yAxisData,
                    type: 'bar',
                    label: {
                        show: true,
                        position: 'top'
                    },
                    barWidth: 50
                }
            ]
        })
    },
    handleChartResize() {
      if (this.gasDistChart) {
        this.gasDistChart.resize();
      }
    }
  },    
  
}
</script>

<style lang="scss" scoped>
@import "./variables.scss";
// ========== Layout ==========
.dashboard-page {
  background-color: $page-bg;
  padding: 12px;
  min-height: calc(100vh - 100px);
  box-sizing: border-box;
}
// ========== Stats Cards ==========
.stats-row {
  display: flex;
  gap: $spacing-md;
  margin-bottom: $spacing-lg;

  .stat-card {
    flex: 1;
    background: $card-bg;
    border-radius: $radius-md;
    padding: $spacing-lg $spacing-md;
    display: flex;
    align-items: center;
    gap: $spacing-md;
    box-shadow: $shadow-sm;
    border-left: 4px solid transparent;

    &--blue { border-left-color: $primary; }
    &--red { border-left-color: $danger; }
    &--orange { border-left-color: $warning; }
    &--green { border-left-color: $success; }

    .stat-icon {
      font-size: 28px;
      width: 48px;
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: $radius-sm;
    }

    .stat-info {
      display: flex;
      flex-direction: column;

      .stat-label {
        font-size: $font-size-sm;
        color: $text-secondary;
        margin-bottom: $spacing-xs;
      }

      .stat-value {
        font-size: 28px;
        font-weight: 700;
        color: $text-primary;
      }
    }
  }
}

// ========== Charts Row ==========
.charts-row {
  display: flex;
  gap: $spacing-md;
  margin-bottom: $spacing-lg;

  .chart-card {
    background: $card-bg;
    border-radius: $radius-md;
    padding: $spacing-lg;
    box-shadow: $shadow-sm;

    &--left {
      flex: 1;
    }

    &--right {
      flex: 2;
    }
  }

  .card-title {
    font-size: $font-size-lg;
    font-weight: 600;
    color: $text-primary;
    margin-bottom: $spacing-lg;
  }
}

// ========== Bar Chart ==========
.bar-chart {
  display: flex;
  flex-direction: column;
  gap: $spacing-lg;
  padding: $spacing-sm 0;

  
}

// ========== Village Grid ==========
.village-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: $spacing-md;

  .village-mini-card {
    background: #F8FAFC;
    border: 1px solid $border-color;
    border-radius: $radius-md;
    padding: $spacing-md;
    display: flex;
    flex-direction: column;
    gap: $spacing-sm;
    transition: all 0.2s;

    &:hover {
      border-color: $primary;
      background: $primary-light;
    }
  }

  .village-mini-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .village-mini-name {
    font-size: $font-size-base;
    font-weight: 600;
    color: $text-primary;
  }

  .village-mini-stats {
    display: flex;
    gap: $spacing-sm;
    font-size: $font-size-xs;
    color: $text-secondary;
    flex-wrap: wrap;

    .village-stat-item em {
      font-style: normal;
      font-weight: 600;
      color: $text-primary;
    }
  }

  .village-mini-link {
    font-size: $font-size-xs;
    color: $primary;
    text-align: right;
    align-self: flex-end;
    margin-top: $spacing-xs;

    &:hover {
      text-decoration: underline;
    }
  }
}

// ========== Table Section ==========
.table-section {
  background: $card-bg;
  border-radius: $radius-md;
  padding: $spacing-lg;
  box-shadow: $shadow-sm;

  .card-title {
    font-size: $font-size-lg;
    font-weight: 600;
    color: $text-primary;
    margin-bottom: $spacing-md;
  }

  .table-footer {
    margin-top: $spacing-md;
    text-align: right;

    .view-all-link {
      font-size: $font-size-sm;
      color: $primary;
      font-weight: 500;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}

// ========== Table Header Style ==========
:deep(.table-header-cell) {
  font-weight: 600;
  color: $text-secondary;
  background: $table-header-bg;
}
</style>
